export default "__VITE_ASSET__BVNb1HL$__"